<div class="wrap"
     [style.background-image]="'url(../../../../assets/images/backgrounds/City1470797.svg)'"
>
    <app-gg-login-form
            *ngIf="(ggAuthService.loginStateSub.asObservable()|async).state === 'login'">
    </app-gg-login-form>
    <app-gg-activate-form
            *ngIf="(ggAuthService.loginStateSub.asObservable()|async).state === 'activate'">
    </app-gg-activate-form>
</div>
